import './App.css';
import { Routes, Route } from "react-router-dom";
import { useSelector } from 'react-redux';
import useAutoLogout from './hooks/useAutoLogout'; // Import the auto-logout hook
import HomeV3 from './Components/Pages/HomeV3';
import FAQ from './Components/FAQ';
import ContactUs from './Components/Pages/ContactUs';
import TuitionPaymentPage from './Components/Pages/TuitionPaymentPage';
import TermsOfUse from './Components/Pages/TermsOfUse';
import About from './Components/Pages/About';

import Blog from './Components/Pages/Blog';
import PrivacyPolicy from './Components/Pages/PrivacyPolicy';
import BookFlight from './Components/Pages/BookFlight';
import BookFlightCom from './Components/Pages/BookFlightCom';
import TravelInsurance from './Components/Pages/TravelInsurance';
import CurrencyConverter from './Components/Pages/CurrencyConverter';
import GlobalAccount from './Components/Pages/GlobalAccount';
import TuitionPayment from './Components/Pages/BlogDetails/TuitionPayment';
import StudentLoanBlog from './Components/Pages/BlogDetails/StudentLoan';
import VitualCardPageV3 from './Components/Pages/VirtualCardPageV3';
import BillsPaymentV3 from './Components/Pages/BillsPaymentV3';
import MoneyTransferV3 from './Components/Pages/MoneyTransferV3';
import NewRegister from './Components/Pages/Auth/NewRegister';
import GlobalFinancialConnectivityBlog from './Components/Pages/BlogDetails/GlobalFinancialConnectivityBlog';

// Create a wrapper component that uses the auto-logout hook
const AppWithAutoLogout = () => {
  const userLoginData = useSelector((state: any) => state.data.login.value);

  // Only activate auto-logout if user is logged in
  useAutoLogout();

  return (
    <div>
      {/* <Navbar/> */}
      <Routes>
        <Route path="/sign-up" element={<NewRegister />} />
        <Route path="/currency-converter" element={<CurrencyConverter />} />
        <Route path="/" element={<HomeV3 />} />
        <Route path="/terms-of-use" element={<TermsOfUse />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/about-us" element={<About />} />
        <Route path="/faq" element={<FAQ />} />
        <Route path="/book-flight" element={<BookFlight />} />
        <Route path="/bookflight" element={<BookFlightCom />} />
        <Route path="/health-travel-insurance" element={<TravelInsurance />} />
        <Route path="/tuition-payment" element={<TuitionPaymentPage />} />
        <Route path="/contact-us" element={<ContactUs />} />
        <Route path="/money-transfer" element={<MoneyTransferV3 />} />
        <Route path="/bills-payment" element={<BillsPaymentV3 />} />
        <Route path="/global-account" element={<GlobalAccount />} />
        <Route path="/vitual-card-page" element={<VitualCardPageV3 />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="/tuition-payment-blog" element={<TuitionPayment />} />
        <Route path="/student-loan-blog" element={<StudentLoanBlog />} />
        <Route path="/global-financial-connectivity-blog" element={<GlobalFinancialConnectivityBlog />} />
      </Routes>
      {/* <Nav/> */}
    </div>
  );
};

function App() {
  return (
    <AppWithAutoLogout />
  );
}

export default App;